<script lang="ts">
    import VpStarFilledIcon from '@decathlon-experience/icons/svelte/VpStarFilledIcon';

    import { trans } from '$assets/shop-translator.js';
    import SearchBar from '$saga/views/Search/SearchBar.svelte';

    export let title: string;
</script>

<div
    class="absolute left-1/2 top-[8%] z-10 w-full -translate-x-1/2 p-l text-2xl font-semibold text-white backdrop-blur-[1px] desktop:top-[25%] desktop:px-5xl desktop:text-[26px] max-w-layout-max text-center desktop:text-left"
>
    <h1 class="relative font-dkt-brand desktop:text-[2.5rem]">
        {title}
    </h1>
    <div
        class="text-xs desktop:text-base text-white font-medium flex gap-xs desktop:gap-m mt-xs justify-center desktop:justify-start"
    >
        <span class="flex gap-2xs">
            <span class="text-content-on-brand-accent"
                >{trans('homepage.banner.trust.trips')}</span
            >
            <span>{trans('homepage.banner.trust.trips_suffix')}</span>
        </span>
        <span class="flex gap-2xs">
            <span class="text-content-on-brand-accent"
                >{trans('homepage.banner.trust.travellers_count')}</span
            >
            <span>{trans('homepage.banner.trust.travellers_suffix')}</span>
        </span>
        <span class="flex items-center gap-2xs">
            <span class="size-m">
                <!-- google svg  -->
                <svg
                    viewBox="-26.2 -26.2 314.4 314.4"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid"
                    ><rect
                        x="-26.2"
                        y="-26.2"
                        width="314.4"
                        height="314.4"
                        rx="157.2"
                        fill="#fff"
                    /><g stroke-linecap="round" stroke-linejoin="round" /><path
                        d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
                        fill="#4285f4"
                    /><path
                        d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
                        fill="#34a853"
                    /><path
                        d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
                        fill="#fbbc05"
                    /><path
                        d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
                        fill="#eb4335"
                    /></svg
                >
            </span>
            <span class="desktop:hidden">
                <VpStarFilledIcon size={16} class="text-commercial-catchy" />
            </span>
            <span class="hidden desktop:flex items-center">
                <VpStarFilledIcon size={16} class="text-commercial-catchy" />
                <VpStarFilledIcon size={16} class="text-commercial-catchy" />
                <VpStarFilledIcon size={16} class="text-commercial-catchy" />
                <VpStarFilledIcon size={16} class="text-commercial-catchy" />
                <VpStarFilledIcon size={16} class="text-commercial-catchy" />
            </span>
            <span>{trans('homepage.banner.trust.google_review')}</span>
        </span>
    </div>
</div>

<SearchBar />
